import { Search } from "lucide-react";

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
}

/** Search field filtering products by title, code, or description. */
export default function SearchBox({ value, onChange }: SearchBoxProps) {
  return (
    <div className="agd:relative agd:mb-5 agd:max-md:mb-4">
      <Search
        size={16}
        className="agd:pointer-events-none agd:absolute agd:left-3.5 agd:top-1/2 agd:-translate-y-1/2 agd:text-muted-foreground"
      />
      <input
        type="text"
        autoComplete="off"
        placeholder="Search title, code, or description"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        // Inline padding wins over the higher-specificity input reset in index.css
        // ([id^="agd-"][id$="-root"] input), which would otherwise clobber pl-10 and
        // let the search icon overlap the text.
        style={{ padding: "11px 14px 11px 42px" }}
        className="agd:w-full agd:rounded-lg agd:border agd:border-[#cbd5e0] agd:bg-white agd:text-[0.9rem] agd:text-foreground focus:agd:border-primary focus:agd:outline-none focus:agd:ring-2 focus:agd:ring-primary/20 agd:max-md:text-[12.5px]"
      />
    </div>
  );
}
